import { Typography } from "@mui/material";
import type { ReactNode } from "react";

type DashboardEmptyStateTextProps = {
  children: ReactNode;
};

export const DashboardEmptyStateText = ({
  children,
}: DashboardEmptyStateTextProps) => (
  <Typography
    variant="body2"
    color="text.secondary"
    className="pl-[7px] pt-[7px]"
  >
    {children}
  </Typography>
);
